import { AavoForm } from "src/components/common/forms/AavoForm.tsx";
import { FormCommonProps } from "src/components/common/forms/types.ts";
import { FormNumberField } from "src/components/common/forms/fields/FormNumberField.tsx";
import i18n from "i18next";
import { SalesContractSalesPartsDataGridApi } from "src/api/generated/erp/sales/pricing/api/salesContractSalesPartsDataGridApi.ts";
import { formatLabelWithCurrencyCode } from "src/components/views/erp/sales/salesUtils.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface SalesContractSalesPartPriceFormProps extends FormCommonProps<number> {
	salesContractSalesPartId: number;
	price: number;
	currencyCode: string;
}

interface FormValues {
	price: number;
}

export const SalesContractSalesPartPriceForm = ({
	salesContractSalesPartId,
	price,
	currencyCode,
	onCompleted,
	onFormEdited,
}: SalesContractSalesPartPriceFormProps) => {
	return (
		<AavoForm<FormValues, number>
			onCompleted={onCompleted}
			onFormEdited={onFormEdited}
			defaultValues={{ price: price }}
			agentContext={{
				key: defineAgentUiContextKey("erp.sales.pricing.salesContractSalesPartPrice.form"),
				title: i18n.t("edit_price"),
				data: {
					salesContractSalesPartId,
					currencyCode,
				},
			}}
			render={({ control }) => (
				<FormNumberField
					control={control}
					name={"price"}
					label={formatLabelWithCurrencyCode(i18n.t("price_in_sales_currency"), currencyCode)}
				/>
			)}
			submit={async (values) => {
				await SalesContractSalesPartsDataGridApi.update({
					salesContractSalesPartId: salesContractSalesPartId,
					price: values.price,
				});
				return salesContractSalesPartId;
			}}
		/>
	);
};
